module.exports = __webpack_public_path__ + "img/reward.58dac569.png";